import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAppsComponent } from "./med-icon-apps.component";

@NgModule({
  declarations: [
    MedIconAppsComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAppsComponent,
  ],
})
export class MedIconAppsModule { }
